module.exports = __webpack_public_path__ + "static/media/Close-X.a7e79924.svg";